import equal from 'fast-deep-equal';

import type { NavigationScreenState } from './types';

/**
 * Compare two navigation screens.
 */
export function areNavigationScreensEqual(
    a: NavigationScreenState,
    b: NavigationScreenState
): boolean {
    if (a.type !== b.type) {
        return false;
    }

    return equal(a, b);
}
